<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card>
            <template slot="header">
              <div class="row">
                <div class="col-md-6">
                  <h4 class="card-title">Riepilogo trattamenti</h4>
                  <button class="btnPrint" v-on:click="generatePDF()"><i class="fa fa-print"></i> Stampa tutti</button> 
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="control-label">
                      Mese
                    </label>
                    <date-picker
                            class="riepilogo-mensile-date-picker"
                            type="month"
                            lang="it"
                            :clearable=false
                            value-type="date"
                            :format="monthFormat"
                            label="Giorno"
                            v-model="giorno">
                    </date-picker>
                  </div>
                </div>
              </div>
            </template>
            <p v-if="loading" class="card-category">
              <center>{{ loadingText }}</center>
            </p>
            <div class="row" v-if="!loading">
              <div class="table-trattamenti-mensili" :style="{'max-width':'100%','max-height':Math.max(200,window.height-200)+'px'}">
                <vue-scrolling-table class="table" deadAreaColor="#FFF">
                  <template slot="thead">
                    <tr>
                      <th style="width:160px !important;min-width:160px !important;max-width:160px !important;"></th>
                      <th style="width:120px !important;min-width:120px !important;max-width:120px !important;" v-for="ortaggio in ortaggi">{{ ortaggio.nome }}</th>
                    </tr>
                  </template>
                  <template slot="tbody">
                    <tr v-for="farmaco in farmaci">
                      <td style="width:160px !important;min-width:160px !important;max-width:160px !important;">{{ farmaco.nome }}</td>
                      <td style="width:120px !important;min-width:120px !important;max-width:120px !important;" v-for="ortaggio in ortaggi" class="trattamenti-mensili">
                        {{ getTotaleFarmacoOrtaggio(farmaco.id, ortaggio.id) }}
                      </td>
                    </tr>
                  </template>
                </vue-scrolling-table>
              </div>
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Card from 'src/components/UIComponents/Cards/Card.vue'
  import VueScrollingTable from 'vue-scrolling-table'
  
  export default {
    components: {
      Card,
      VueScrollingTable
    },
    data () {
      return {
        countCaricaGiorno: 0,
        erroreSalvataggio: '',
        loading: true,
        loadingText: 'Caricamento in corso...',
        backendPath: 'trattamenti/report-mese',
        giorno: null,
        farmaci: [],
        ortaggi: [],
        trattamento: [],
        monthFormat: {
          stringify: (date) => {
            if (date instanceof Date) {
              var tzoffset = date.getTimezoneOffset() * 60000
              var strDate = (new Date(date.getTime() - tzoffset)).toISOString().substr(0, 19).replace('T', ' ')
              var anno = strDate.substr(0, 4)
              var mese = parseInt(strDate.substr(5, 2)) - 1
              var arrayMesi = ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre']
              return arrayMesi[mese] + ' ' + anno
            }
            return ''
          },
          parse: (value) => {
            if (typeof value === 'string') {
              var mmaa = value.trim().split(' ')
              if (mmaa.length !== 2) {
                return null
              }
              var anno = mmaa[1]
              var arrayMesi = ['GENNAIO', 'FEBBRAIO', 'MARZO', 'APRILE', 'MAGGIO', 'GIUGNO', 'LUGLIO', 'AGOSTO', 'SETTEMBRE', 'OTTOBRE', 'NOVEMBRE', 'DICEMBRE']
              var meseMenoUno = arrayMesi.indexOf(mmaa[0].toUpperCase())
              if (meseMenoUno !== -1) {
                var date = new Date()
                date.setMonth(meseMenoUno)
                date.setYear(anno)
                return date
              }
            }
            return null
          }
        },
        window: {
          width: 0,
          height: 0
        }
      }
    },
    created () {
      window.addEventListener('resize', this.handleResize)
      this.handleResize()
    },
    destroyed () {
      window.removeEventListener('resize', this.handleResize)
    },
    mounted () {
      var me = this
      me.$data.giorno = new Date()
    },
    watch: {
      giorno (value) {
        var me = this
        if (value instanceof Date && value.getTime()) {
          var mese = this.dateToString(value).substr(0, 7)
          me.caricaGiorno(mese)
        } else {
          me.resettaData()
        }
      }
    },
    methods: {
      handleResize () {
        this.window.width = window.innerWidth
        this.window.height = window.innerHeight
      },
      resettaData () {
        var me = this
        me.$data.loading = true
        me.$data.loadingText = 'Caricamento in corso...'
        me.$data.backendPath = 'trattamenti/report-mese'
        me.$data.farmaci = []
        me.$data.ortaggi = []
        me.$data.trattamento = []
      },
      caricaGiorno: function (giorno) {
        var me = this
        me.resettaData()
        var countCaricaGiorno = ++me.$data.countCaricaGiorno
        if (!giorno) {
          return
        }
        var url = process.env.API_URL + me.$data.backendPath + '/' + giorno
        var method = 'GET'
        var params = {}
        var successFn = function (data) {
          if (countCaricaGiorno !== me.$data.countCaricaGiorno) {
            return
          }
          var trattamento = {}
          for (var f in data.farmaci) {
            var idF = data.farmaci[f].id
            trattamento[idF] = {}
            for (var o in data.ortaggi) {
              var idO = data.ortaggi[o].id
              if (data.dosi[idF] && data.dosi[idF][idO]) {
                trattamento[idF][idO] = data.dosi[idF][idO]
              }
            }
          }
          me.$data.loading = false
          me.$data.farmaci = data.farmaci
          me.$data.ortaggi = data.ortaggi
          me.$data.trattamento = trattamento
        }
        var errorFn = function (message) {
          if (typeof message === 'undefined') {
            message = 'Network Error'
          }
          me.$data.loadingText = 'Errore: ' + message
          me.ajaxErrorFn(message)
        }
        this.ajax(url, method, params, successFn, errorFn)
      },
      getTotaleOrtaggio (idO) {
        var trattamento = this.$data.trattamento
        var tot = 0
        for (var idF in trattamento) {
          if (trattamento[idF][idO]) {
            tot += parseInt(trattamento[idF][idO])
          }
        }
        return tot
      },
      getTotaleFarmacoOrtaggio (idF, idO) {
        var trattamento = this.$data.trattamento
        var tot = 0
        if (trattamento[idF] && trattamento[idF][idO]) {
          tot = parseInt(trattamento[idF][idO])
        }
        return tot
      },
      generatePDF () {
        var anno = this.$data.giorno.getFullYear()
        var mese = this.$data.giorno.getMonth() + 1
        if (mese < 10) {
          mese = '0' + mese
        }
        window.open('https://cortassa.ideadinamica.it/api/pdf/trattamenti/?date=' + anno + '-' + mese, '_blank')
        /* window.open('https://localhost/dinamica/cortassa/api/pdf/trattamenti/?date=' + anno + '-' + mese, '_blank') */
      }
    }
  }

</script>
<style>
.trattamenti-mensili{
  text-align: right;
  min-width: 80px;
  padding: 12px 16px !important;
}
.trattamenti-mensili-totali{
  text-align: right;
  font-weight: bold;
  padding: 12px 16px !important;
  white-space: nowrap;
}
.table-trattamenti-mensili th{
  text-align: center !important;
}
.trattamenti-mensili-paga-oraria{
  text-align: right;
  padding: 12px 16px !important;
  white-space: nowrap;
}
.riepilogo-mensile-date-picker{
  display: block;
}
.riepilogo-mensile-date-picker input {
  font-size: 1rem !important;
  line-height: 1.5;
  height: 40px;
}
.riepilogo-mensile-date-picker {
  width: 100%;
}

.table-trattamenti-mensili thead td:first-child,
.table-trattamenti-mensili tbody td:first-child,
.table-trattamenti-mensili thead th:first-child,
.table-trattamenti-mensili tbody th:first-child {
	position: sticky;
	position: -webkit-sticky;
	left: 0;
  z-index:1;
  background-color: #f7f7f7;
}

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/RiepilogoTrattamenti.vue